import(/* webpackMode: "eager", webpackExports: ["JotaiProvider"] */ "/var/www/coco-app-platformhk/app/[locale]/components/providers/JotaiProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionAuthProvider"] */ "/var/www/coco-app-platformhk/app/[locale]/components/providers/SessionAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrpcContextProvider"] */ "/var/www/coco-app-platformhk/app/[locale]/components/providers/TrpcContextProvider.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/coco-app-platformhk/app/[locale]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/coco-app-platformhk/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/coco-app-platformhk/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/coco-app-platformhk/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/coco-app-platformhk/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/coco-app-platformhk/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
